import { defineMessages } from "react-intl";

export const giftCardExpirySelectMessages = defineMessages({
  expiryDateCheckboxLabel: {
    id: "JKbpH9",
    defaultMessage: "Gift card expires",
    description: "expiry date checkbox label",
  },
  expiryDateLabel: {
    id: "nFTvQW",
    defaultMessage: "Expiration date",
    description: "expiration date label",
  },
  expiredOnLabel: {
    id: "//k1GX",
    defaultMessage: "Expired on {date}",
    description: "expired on label",
  },
});
